const routes = [
  {
    name: 'publistMessageDetail',
    path: '/publish-message/detail',
    component: () => import('@pages/publish-message/index'),
  }
]

export default routes;